import { getBrowserAudios } from "../flow";

export function setMuted(muted: boolean) {
    getBrowserAudios().forEach((audio) => (audio.element.muted = muted));
}
